import BotDialogType from '../../core/type/dialog/BotDialogType';
import TextInputType from '../../core/type/input/TextInputType';
import UserDialogType from '../../core/type/dialog/UserDialogType';
import { sendBotResponse } from './util';
import Interceptor from '../../core/type/operation/Interceptor';
import SelectorInputType from '../../core/type/input/SelectorInputType';
import ButtonInputType from '../../core/type/input/ButtonInputType';
import Switch from '../../core/type/operation/Switch';
import Case from '../../core/type/operation/Case';

export default [
  new BotDialogType({
    message: 'Olá, tudo bem? O nosso objetivo aqui é te ajudar a encontrar o parceiro ideal para a sua necessidade. Para isso, preciso te fazer umas perguntas.',
    checkpoint: true,
  }),
  new BotDialogType({
    message: 'Primeiramente, como posso te chamar?',
    checkpoint: true,
  }),
  new TextInputType({
    placeholder: 'Digite seu nome completo',
    key: 'name',
  }),
  new Interceptor(async (data) => new Promise((resolve) => {
    const newData = data;
    const firstname = data.name.split(' ')[0];
    newData.first_name = firstname.charAt(0).toUpperCase() + firstname.slice(1);
    resolve({ ...newData });
  })),
  new UserDialogType({
    message: 'Meu nome é #{name}.',
  }),

  // new BotDialogType({
  //   message: 'Legal #{first_name}. E em qual dessas categorias você se encaixa melhor?',
  //   checkpoint: true,
  // }),

  // new SelectorInputType({
  //   key: 'fit_category',
  //   type: 'radio',
  //   column: 'half',
  //   options: 'fit_category_options',
  // }),

  // new Interceptor(async (data) => new Promise((resolve) => {
  //   resolve({
  //     ...data,
  //     information: { ...data.information, fit_category: data.fit_category },
  //     fit_category: data.fit_category.value,
  //   });
  // })),

  // new BotDialogType({
  //   message: 'Legal #{first_name}. Você tem uma empresa? Se sim, qual é o nome?',
  //   checkpoint: true,
  // }),
  // new TextInputType({
  //   placeholder: 'Ex: Capsule Corp',
  //   key: 'company_name',
  //   suggestionsId: 'no_company_options',
  // }),
  // new UserDialogType({
  //   message: '#{company_name}',
  // }),

  new BotDialogType({
    message: 'Certo, agora selecione qual o seu segmento de atuação.',
    checkpoint: true,
  }),
  new SelectorInputType({
    key: 'company_segment',
    type: 'buttonSelector',
    options: 'segment_options',
  }),

  new Interceptor(async (data) => new Promise((resolve) => {
    resolve({
      ...data,
      information: { ...data.information, company_segment: data.company_segment },
      company_segment: data.company_segment.value,
    });
  })),

  new UserDialogType({
    message: '#{company_segment}',
  }),

  new Switch({
    ref: 'company_segment',
    cases: [
      new Case({
        express: '\'$v\' === \'Outros\'',
        components: [
          new BotDialogType({
            message: 'Pode nos informar qual outro segmento que não estava listado?',
            checkpoint: true,
          }),

          new TextInputType({
            key: 'other_company_segment',
          }),

          new UserDialogType({
            message: '#{other_company_segment}',
          }),

        ],
      }),
    ],
  }),

  new BotDialogType({
    message: 'Qual o seu nível de experiência com vendas online?',
    checkpoint: true,
  }),

  new ButtonInputType({
    key: 'expertize_level',
    buttons: [
      { value: 'HAS_SALE', text: 'Já realizei minha primeira venda' },
      { value: 'NO_SALE', text: 'Em busca da primeira venda' },
    ],
  }),

  new UserDialogType({
    message: '#{expertize_level.text}',
  }),

  new Switch({
    ref: 'expertize_level',
    cases: [
      new Case({
        express: '\'$v\' === \'NO_SALE\'',
        components: [
          new BotDialogType({
            message: 'Entendi! E o seu produto já está pronto?',
            checkpoint: true,
          }),

          new ButtonInputType({
            key: 'product_status',
            buttons: [
              { value: 'READY', text: 'Meu produto está pronto' },
              { value: 'NOT_READY', text: 'Não está pronto' },
              { value: 'ONLY_IDEA', text: 'Só tenho a ideia' },
            ],
          }),

          new Interceptor(async (data) => new Promise((resolve) => {
            resolve({
              ...data,
              information: { ...data.information, product_status: data.product_status },
              product_status: data.product_status.text,
            });
          })),

          new UserDialogType({
            message: '#{product_status}',
          }),

        ],
      }),
    ],
  }),

  new Interceptor(async (data) => new Promise((resolve) => {
    resolve({
      ...data,
      information: { ...data.information, expertize_level: data.expertize_level },
      expertize_level: data.expertize_level.text,
    });
  })),

  new BotDialogType({
    message: 'Para que possamos continuar, eu preciso saber seu e-mail.',
  }),

  new TextInputType({
    placeholder: 'Digite seu e-mail',
    key: 'email',
    validation: 'email',
  }),

  new UserDialogType({
    message: 'Meu email é #{email}',
  }),
  new BotDialogType({
    message: 'E agora, seu celular.',
  }),
  new TextInputType({
    placeholder: 'Informe seu celular',
    validation: 'phone',
    key: 'phone',
    defaultData: 'phone',
    mask: '(99) 99999-9999',
  }),

  new UserDialogType({
    message: '#{phone}.',
  }),

  new BotDialogType({
    message: 'Certo! Para te conhecer melhor, me informe suas redes sociais e links importantes como seu site ou a página de venda do seu produto.',
    checkpoint: true,
  }),

  new TextInputType({
    placeholder: 'redes sociais, página de vendas, websites, etc...',
    key: 'links',
    textareaMode: true,
    optional: true,
  }),

  new UserDialogType({
    message: '#{links}.',
  }),

  sendBotResponse(),
];
